import { ToastContainer } from 'react-toastify';
import React, { useContext, useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom';
import axios from 'axios';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faClock, faHeart, faLocationDot, faMoneyBillWave, faXmark } from "@fortawesome/free-solid-svg-icons";
import '../../../Home/EventCard/EventCard.css'
import { faCalendarDays} from "@fortawesome/free-solid-svg-icons";
import TicketContext from './TicketContext';
import './MyTickets.css'
import GoogleMaps from './GoogleMaps';



const ViewTicket = () => {

    const [isLoading,setIsLoading] = useState(true);
    const {showTicket, handleShowTicket,currTicket} = useContext(TicketContext)
    const [hours,setHours] = useState();
    const [minutes,setMinutes] = useState();
    const [totalPrice,setTotalPrice] = useState(0);
    
    const handleCross = () => {
        handleShowTicket();
      };


    useEffect(()=> {
        setHours(Math.floor(currTicket.event.duration / 60));
        setMinutes(currTicket.event.duration % 60);
        setTotalPrice(currTicket.numberOfTickets * currTicket.event.ticketPrice);
        setIsLoading(false)
    },[currTicket])

  return (
    <div className='ticket-outer-container margin-top-reduce'>
                {!isLoading && showTicket?<>
            <div className='event-detail-container mobile-detail-container'>
              <ToastContainer/>
              <div className='event-divs'>
                <div className='event-divs-row'>
                <FontAwesomeIcon className='grey' style={{marginRight:"0.6em"}} icon={faCalendarDays} />
              <p> {currTicket.event.date.split("T")[0]}</p>
              <FontAwesomeIcon className='grey' style={{margin:"0px 0.6em"}} icon={faClock} />
               <p>{currTicket.event.time} GMT</p>
                </div>
                <div className='event-divs-row'>
                <p>Duration: {hours}h {minutes}m</p>
                <div onClick={handleCross} className="cross-mark margin-left">
            <FontAwesomeIcon icon={faXmark} />
          </div>
                </div>
                
              </div>
        <div className="event-detail">
            <h1>{currTicket.event.title}</h1>
            <h4>{currTicket.event.description}</h4>
            <div className='event-card-location'>
            <FontAwesomeIcon className='grey' icon={faLocationDot} />
            <h5 style={{marginLeft:"0.5em"}}> {currTicket.event.location.address}, {currTicket.event.location.pincode} , {currTicket.event.location.city} </h5>
            </div>
            {currTicket.event.location.latitude && currTicket.event.location.longitude ? <GoogleMaps lat={currTicket.event.location.latitude} lng={currTicket.event.location.longitude}/> : ""}
            <div className='event-card-location price'>
            <FontAwesomeIcon className='grey' icon={faMoneyBillWave} />
            <h5 style={{marginLeft:"0.5em"}}>{currTicket.event.ticketPrice === 0 ? "Free" : "Paid: £ "+ totalPrice}</h5>
            </div>
            <div className='event-card-location code-div'>
            <h5>Ticket Code: {currTicket.ticketCode}</h5>
            <h5>No. of Tickets: {currTicket.numberOfTickets}</h5>
            </div>
            <div className='event-card-location qrCode-div'>
            <img className='ticket-qrCode' src={currTicket.qrCode} alt='ticket QRCode'/>
            </div>
           
           
        </div>
        </div>
        </> : <div>Loading</div>}
    </div>
  )
}

export default ViewTicket